const NotFound = () => {
	return (
		<div className='pagenoFound'>
			<img src='../404.png' alt='not found' />
		</div>
	);
};

export default NotFound;
